const getters = {
    getPurchaseList(state){
        return state.purchaseList;
    },
    getSuppliers(state){
        return state.suppliers;
    },
    getStatuses(state) {
        return state.statuses;
      },
    getPurchase(state){
        return state.purchase;
    },
   
    
}

export default getters;
